import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  fetchUser,
  fetchUserStatistic,
  logout,
} from "store/user/user.slice";
import { LoadingOutlined } from "@ant-design/icons";
import { LiaSignOutAltSolid } from "react-icons/lia";
import { TbShoppingBagCheck, TbShoppingBagEdit } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { IoHeartOutline } from "react-icons/io5";

import "./UserDetail.scss";
import LinkLanguage from "locales/LinkLanguage";

const UserDetail = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { user_details, user_statistic } = useSelector(
    (store: any) => store.user
  );

  useEffect(() => {
    dispatch(fetchUser(null));
    dispatch(fetchUserStatistic(null));
  }, [dispatch]);

  const logoutUser = async () => {
    dispatch(logout());
    navigate("/login");
  };
  const changePassword = () => {
    navigate("/profile/change-password");
  };
  const changeAddress = () => {
    navigate("/profile/change-address", { state: user_details.address });
  };

  return (
    <div className="Page">
      <div className="Page-Content">
        <div className="User-Detail">
          <h2>Moj nalog</h2>
          <button onClick={() => logoutUser()} className="button-icon">
            <LiaSignOutAltSolid />
            Odjavi me
          </button>
        </div>
        {user_details.id ? (
          <div className="User-Detail-Vertical">
            <label>
              Sa vaše kontrolne table naloga možete da pregledate pregled
              nedavne aktivnosti na nalogu i ažurirate podatke o nalogu.
            </label>
            <label>
              Izaberite link ispod da biste pregledali ili izmenili informacije.
            </label>
            <div className="User-Detail-Content">
              <div className="User-Detail-Col1">
                <h3>
                  Pozdrav{" "}
                  <strong>
                    {" "}
                    {user_details.user_firstname +
                      " " +
                      user_details.user_lastname}
                  </strong>
                  !
                </h3>
                <div className="User-Detail-Vertical User-Detail-Data">
                  <div className="User-Detail-Text">
                    <h4>Informacije o nalogu</h4>
                    <button className="button-link" onClick={changePassword}>
                      Izmjeni lozinku
                    </button>
                  </div>
                  <label>
                    {user_details.user_firstname +
                      " " +
                      user_details.user_lastname}
                  </label>
                  <label>{user_details.email}</label>

                  {/* <div>
                    {user_details.roles.map((role: any) => (
                      <label className="Label-Block">{role.role_name}</label>
                    ))}
                  </div> */}
                </div>

                <div className="User-Detail-Vertical User-Detail-Data">
                  <div className="User-Detail-Text">
                    <h4>Adresa</h4>
                    <button className="button-link" onClick={changeAddress}>
                      Izmjeni
                    </button>
                  </div>
                  {user_details.address ? (
                    <>
                      <label>
                        {user_details.address.street_name +
                          " " +
                          user_details.address.street_number}
                      </label>
                      <label>
                        {user_details.address.location +
                          " " +
                          user_details.address.city_name +
                          " " +
                          user_details.address.zip}
                      </label>
                      <label>{user_details.address.region_name}</label>
                      <label>{user_details.address.state_name}</label>
                    </>
                  ) : (
                    <label>Nije kreirana</label>
                  )}
                </div>
              </div>
              <div className="User-Detail-Col2">
                <LinkLanguage
                  to="/profile/finished-orders"
                  className="User-Detail-Box"
                  title={`Vidi detaljno`}
                >
                  <TbShoppingBagCheck
                    size={"40%"}
                    className="User-Detail-Box-Icon"
                  />
                  <p>Ukupno narudžba</p>
                  {user_statistic.is_fetch && (
                    <h2 className="font-medium">
                      {user_statistic.data.num_of_finished_orders}
                    </h2>
                  )}
                </LinkLanguage>

                <LinkLanguage
                  to="/profile/orders"
                  className="User-Detail-Box"
                  title={`Vidi detaljno`}
                >
                  <TbShoppingBagEdit
                    size={"40%"}
                    className="User-Detail-Box-Icon"
                  />
                  <p>Na čekanju </p>
                  {user_statistic.is_fetch && (
                    <h2 className="font-medium">
                      {user_statistic.data.num_of_current_orders}
                    </h2>
                  )}
                </LinkLanguage>

                <LinkLanguage
                  to="/profile/favorite"
                  className="User-Detail-Box"
                  title={`Vidi detaljno`}
                >
                  <IoHeartOutline
                    size={"40%"}
                    className="User-Detail-Box-Icon"
                  />
                  <p>Moji favoriti</p>
                  {user_statistic.is_fetch && (
                    <h2 className="font-medium">
                      {user_statistic.data.num_of_favorite_articles}
                    </h2>
                  )}
                </LinkLanguage>
              </div>
            </div>
          </div>
        ) : (
          <LoadingOutlined />
        )}
      </div>
    </div>
  );
};
export default UserDetail;
